import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { notifyUser } from 'hb-redux-store/feature/products/product.action';
import './product-card.scss';
import Button from '../../common/Button/Button';
import ButtonCounter from '../../common/Button/ButtonCounter';
import {
  getBackgroundImageUrl,
  getDiscountText,
  getPreorderText,
  getSelectedMultipleSkuIndex,
} from 'hb-redux-store/util/miscellaneousServices';
import { Link } from 'react-router-dom';
import Messages from 'components/mweb/Messages/Messages';
import Icon from 'components/mweb/Icon/Icon';
import { setPreorderModal } from 'hb-redux-store/feature/modal/modal.action';
import { createComboProductUrl, createProductUrl } from '../../../CPMapping';
import { showNonServiceableModal } from 'hb-redux-store/feature/modal/modal.action';
import HighLightTags from '../../mweb/HighlightTags/HighlightTags';
import StockLeft from '../../common/StockLeft/StockLeft';
import MultipleSkuDropDown from '../MultipleSku/MultipleSkuDropDown';

class ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.isCart = props.cart || props.shipment;
    const product = props.product;
    if (this.isCart) {
      product.productImage = product.imageUrl;
    }
    const skus = this.isCart
      ? [
          {
            inCartQuantity: product.inCartQty,
            isInventoryAvailable: product.invAvailable,
            isPresale: product.presale,
            maxQuantityCart: product.maxQuantityCart,
            onSale: product.onSale,
            retailPrice: product.retailPrice,
            salePrice: product.salePrice,
            sku: product.sku,
            quantity: product.quantityType,
            skuAttributes: [],
            deliveryStartDate: product.deliveryStartDate,
            deliveryEndDate: product.deliveryEndDate,
            saleDiscountPercentage: product.saleDiscountPercentage,
            saleDiscountFlat: product.saleDiscountFlat,
          },
        ]
      : product.skus;
    this.state = {
      cartQty: skus[0].inCartQuantity,
      opInProgress: false,
      sku: skus[0],
      skus: skus,
      product,
      activeSkuIndex: 0,
      discountText: getDiscountText({
        product,
        isCart: this.isCart,
        isProduct: !this.isCart,
      }),
    };
  }

  componentDidMount() {
    if (!this.isCart) {
      const selectedSkuIndex = getSelectedMultipleSkuIndex(
        this.props?.product?.skus
      );
      this.setState({ sku: this.props?.product?.skus[selectedSkuIndex] });
    }
  }

  addItem = () => {
    this.setState({ opInProgress: true }, () => {
      const { onIncrement, source = '' } = this.props;
      const { product, sku } = this.state;
      const atcData = {
        quantity: 1,
        productName: product?.productName,
        price: sku?.salePrice ?? sku?.retailPrice,
        source,
        successOpCb: this.successOpCb('Item added to cart'),
        failOpCb: this.failOpCb('Error adding item to cart'),
        isCart: this.isCart,
      };
      if (product.comboProduct && product.comboProductId) {
        atcData.comboProductId = product.comboProductId;
      } else {
        atcData.productId = product.productId;
        atcData.sku = sku.sku;
      }
      onIncrement(atcData);
    });
  };

  removeItem = () =>
    this.setState({ opInProgress: true }, () => {
      const { onDecrement, source = '' } = this.props;
      const { product, sku } = this.state;
      const rfcData = {
        quantity: 1,
        productName: product?.productName,
        price: sku?.salePrice ?? sku?.retailPrice,
        source,
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
        isCart: this.isCart,
      };
      if (product.comboProduct && product.comboProductId) {
        rfcData.comboProductId = product.comboProductId;
      } else {
        rfcData.productId = product.productId;
        rfcData.sku = sku.sku;
      }
      onDecrement(rfcData);
    });

  removeSoldOutItem = () => {
    this.setState({ opInProgress: true }, () => {
      const { onDecrement } = this.props;
      const { product, sku } = this.state;
      const rfcData = {
        quantity: 1,
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
        isCart: this.isCart,
      };
      if (product.comboProduct && product.comboProductId) {
        rfcData.comboProductId = product.comboProductId;
      } else {
        rfcData.productId = product.productId;
        rfcData.sku = sku.sku;
      }
      onDecrement(rfcData);
    });
  };

  // notify = () => {
  //   this.props.notifyUser({ sku: this.state.sku.sku, isCart: this.isCart });
  // };
  notify = () => {
    const { setAppNotification, showNonServiceableModal } = this.props;
    if (!this.props.loggedInState) {
      return setAppNotification('Please login to get notified.');
    }
    const { product, sku } = this.state;
    this.props.notifyUser({
      sku: (product.comboProduct && product.comboProductId) || sku.sku,
      isCart: this.isCart,
      errorCb: e => {
        const message =
          e.data?.description ||
          e.data?.error?.errorMessage ||
          'Unable to process your request';
        if (e.status === 401) {
          setAppNotification('Please login to get notified.');
        }
        if (e.status === 500 && message === 'Please select a location.') {
          showNonServiceableModal({ visible: true, source: 'notifyMe' });
        }
      },
    });
  };

  successOpCb = msg => ({ sku: opSku, skuCount }) => {
    let { product, sku } = this.state;
    if (product.comboProduct) {
      const skus = [...this.state.skus];
      skus[0] = { ...skus[0], inCartQuantity: skuCount };
      this.setState({ skus, sku: skus[0], opInProgress: false });
    } else {
      const skus = this.state.skus.map(s => {
        if (opSku === s.sku) {
          s.inCartQuantity = skuCount;
          sku = s;
        }
        return s;
      });
      this.setState({ skus, sku, opInProgress: false });
    }
    this.props.setAppNotification(msg);
  };
  failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      this.props.setAppNotification(errorMessage);
    this.setState({ opInProgress: false });
  };
  getContent = sku => (
    <div className="product-card--info-container">
      <Icon class="icon-pre-order" size={12} />
      <span className="desktop-product-card--product-card--info">
        {getPreorderText(sku)}
      </span>
    </div>
  );
  render() {
    const { shipment, type, cartSkus } = this.props;
    const { product, sku, discountText } = this.state;
    const { message } = product;
    const toLink = product.comboProductId
      ? createComboProductUrl(product.comboProductId)
      : createProductUrl(product.productId);
    const skuCartQty = cartSkus[sku.sku] ?? sku.inCartQuantity;
    const isSearchListingPage = type === 'searchlist';
    const isProductCard = isSearchListingPage || this.isCart;
    const isProductListingCard = !this.isCart && !isSearchListingPage;
    return (
      <React.Fragment>
        <div
          className={`${
            isProductCard
              ? 'desktop-product-card-searchlist'
              : 'desktop-product-card'
          }`}
        >
          {product.isBestSeller && (
            <HighLightTags type="bestseller" source="product-card-desktop" />
          )}
          {sku.onSale && discountText && (
            <div
              className={`desktop-product-card--sale-tag ${
                this.isCart || type === 'searchlist' ? 'cart-sale-tag' : ''
              }`}
            >
              <Icon class="icon-cart-on-sale" size={this.isCart ? 14 : 18} />
              {discountText}
            </div>
          )}

          <Link
            className={`${
              isProductCard
                ? 'desktop-plp--searchlist-product-image'
                : 'desktop-product-card--product-image'
            } ${!sku.isInventoryAvailable ? 'sold-out' : ''}`}
            style={getBackgroundImageUrl(product.productImage)}
            to={toLink}
          />
          {!sku.isInventoryAvailable && (
            <Link
              to={toLink}
              className="desktop-product-card--product-image--sold-out"
            >
              OUT OF STOCK
            </Link>
          )}
          {!this.isCart && type !== 'searchlist' && (
            <Link
              className="desktop-product-card--product-name desktop-product-card--product-name--top"
              to={toLink}
              title={product.productName}
            >
              {product.productName}
            </Link>
            // <div className="justify-content--space-between">
            //   <Link
            //     className="desktop-product-card--product-name desktop-product-card--product-name--top"
            //     to={toLink}
            //     title={product.productName}
            //   >
            //     {product.productName}
            //   </Link>
            //   {this.isCart && !sku.isInventoryAvailable && (
            //     <div
            //       className="desktop-product-card--remove-sold-out  flex-align-items-center"
            //       onClick={this.removeSoldOutItem}
            //     >
            //       <Icon class="icon-cart-remove-item" size={18} />
            //       <Button className="button action-link ">Remove</Button>
            //     </div>
            //   )}
            // </div>
          )}
          {sku.stockLeft && <StockLeft message={sku.stockLeft} />}
          <div
            className={`${
              isProductCard
                ? 'desktop-product-search-details'
                : 'desktop-product-details'
            }`}
          >
            {(this.isCart || type === 'searchlist') && (
              <div className="justify-content--space-between">
                <Link
                  className="desktop-product-card--product-name"
                  to={toLink}
                  alt={product.productName}
                >
                  {product.productName}
                </Link>
                {this.isCart && !sku.isInventoryAvailable && (
                  <div
                    className="desktop-product-card--remove-sold-out  flex-align-items-center"
                    onClick={this.removeSoldOutItem}
                  >
                    <Icon class="icon-cart-remove-item" size={18} />
                    <Button className="button action-link cursor-hover">
                      Remove
                    </Button>
                  </div>
                )}
              </div>
            )}
            {isSearchListingPage && (
              <MultipleSkuDropDown
                containerStyle="desktop-product-card--product-quantity-container"
                product={product}
                sku={sku}
                activeSkuIndex={this.state.activeSkuIndex}
                rightArrow
                setActiveSkuIndex={index => {
                  this.setState({
                    activeSkuIndex: index,
                    sku: product?.skus[index],
                  });
                }}
              />
            )}
            {this.isCart && (
              <div className="desktop-product-card--product-quantity">
                {sku.quantity}
              </div>
            )}
            {isProductListingCard && (
              <MultipleSkuDropDown
                product={product}
                sku={sku}
                activeSkuIndex={this.state.activeSkuIndex}
                setActiveSkuIndex={index => {
                  this.setState({
                    activeSkuIndex: index,
                    sku: product?.skus[index],
                  });
                }}
              />
            )}
            <div className="justify-content--space-between">
              <span>
                <span
                  className={`desktop-product-card--retail-price ${
                    sku.onSale && sku.salePrice > 0 ? 'on-sale' : ''
                  }`}
                >
                  &#8377;{sku.retailPrice}
                </span>
                {sku.onSale && sku.salePrice > 0 && (
                  <span className="desktop-product-card--sale-price">
                    &#8377;{sku.salePrice}
                  </span>
                )}
              </span>
              {!shipment && (
                <span className="desktop-product-card--buttons">
                  {!sku.isInventoryAvailable && (
                    <Button
                      className="button action-link desktop-product-card--notify-me cursor-hover"
                      onClick={this.notify}
                      disabled={this.state.opInProgress}
                    >
                      Notify Me
                    </Button>
                  )}
                  {sku.isInventoryAvailable && skuCartQty === 0 && (
                    <Button
                      className="button button-ghost"
                      onClick={this.addItem}
                      disabled={this.state.opInProgress}
                    >
                      ADD
                    </Button>
                  )}
                  {sku.isInventoryAvailable && skuCartQty > 0 && (
                    <ButtonCounter
                      onIncrement={this.addItem}
                      onDecrement={this.removeItem}
                      className="button-counter-ghost"
                      counter={skuCartQty}
                      disabled={this.state.opInProgress}
                    />
                  )}
                </span>
              )}
              {shipment && (
                <span className="desktop-product-card--shipment-qty">
                  Quantity: {sku.inCartQuantity}
                </span>
              )}
            </div>
            {this.getContent(sku)}
            <div
              className={`desktop-product-card--messages ${
                isProductCard
                  ? 'desktop-product-card--messages--searchlist'
                  : ''
              }`}
            >
              {/*Requested quantity not available, check cart for changes*/}
              {message && message.uiType === 'text' && (
                <div className="desktop-product-card--messages">
                  <Messages type={message.type} message={message.description} />
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ initialReducer, cartReducer }) => ({
  loggedInState: initialReducer.launchInfo.loggedIn,
  cartSkus: cartReducer.cartSkus,
});

const mapDispatchToProps = {
  setAppNotification,
  notifyUser,
  setPreorderModal,
  showNonServiceableModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
